import { MDBDatatable, MDBIcon } from 'mdb-react-ui-kit'
import React, { useEffect, useRef, useState } from 'react'
import PopupLoaderNew from '../../popups/PopupLoaderNew';
import DeleteBlockedUser from '../../popups/securitymanager/DeleteBlockedUser';

function BlockedUser(props) {

    const [blockUserList, setblockUserList] = useState([]);
    const [deleteip, setdeleteip] = useState(false);
        const toggledelete = () => setdeleteip(!deleteip);
        const [blockid, setBlockid] = useState("");
        const [isLoading, setisLoading] = useState(false);
        const addUserRef = useRef(null);
    
        function handleClick() {
            addUserRef.current.click();
        }
    
        const handleBlockUserDelete = (e, ipsInfo) => {
            e.preventDefault();
            console.log(JSON.stringify(ipsInfo));
            setBlockid(ipsInfo.id);
            toggledelete();
        }


    useEffect(() => {
        if (props.blockedUsers && props.blockedUsers.length > 0) {
            setblockUserList(props.blockedUsers);
        }

    }, [props.blockedUsers]);


    let processdrows = [];
    blockUserList.map((user) => {
        processdrows.push({
            userInfo: { ...user },
            username: user.User_Name,
            deviceName: user.Device_Name,
            blockedDate: user.Blocked_Date,
            browserName: user.Browser_Name,
            delete: (
                <div className="d-flex align-items-center justify-content-center">
                    <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => handleBlockUserDelete(e, user)}>
                        <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                    </div>
                </div>
            ),

        })
    })

    const actionData7 = {
        columns: [
            { label: 'Username', field: 'username' },
            { label: 'Device Name', field: 'deviceName' },
            { label: 'Blocked Date', field: 'blockedDate' },
            { label: 'Browser Name', field: 'browserName' },
            { label: 'Delete', field: 'delete', sort: false },
        ],
        rows: processdrows,
        // [
        //     {
        //         username: 'raghuseven@dynamic',
        //         deviceName: 'raghuseven@dynamic',
        //         blockedDate: 'January-04-2023 04:09:48',
        //         browserName: 'Chrome',
        //         delete: (
        //             <div className="d-flex align-items-center justify-content-center">
        //                 <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip">
        //                     <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
        //                 </div>
        //             </div>
        //         ),
        //     },
        //     // Add more rows as necessary
        // ],
    };
    return (
        <>
            <div className="actionbar"></div>

            <div className="SecutityTopViewPage1">
                <MDBDatatable className='actioncolumn' search hover data={actionData7} sortField="Username" sortOrder="asc" entries={50} />
            </div>
            {deleteip && (
                <PopupLoaderNew
                    title={"Delete User"}
                    content={<DeleteBlockedUser
                        id={blockid}
                        onClose={toggledelete}
                        ref={addUserRef}
                        setIsloading={setisLoading}
                    />}
                    onShow={setdeleteip}
                    onClose={toggledelete}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}
        </>
    )
}

export default BlockedUser
